import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteStockvalues
export const DeleteStockvalues = createSlice({
  name: "DeleteStockvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteStockvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteStockvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteStockvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteStockvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteStockvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteStockvalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteStockvalues.reducer;
export const {
  DeleteStockvalues_datagrid,
  success_api_call_DeleteStockvalues_datagrid,
  failure_api_call_DeleteStockvalues_datagrid,
  create_DeleteStockvalues_datagrid_complete_api,
  DeleteStockvalues_datagrid_is_success,false_switchDeleteStockvalues
} = DeleteStockvalues.actions;
